module.exports = __webpack_public_path__ + "img/en_backgroundImg.f246c6db.jpg";